export const API = process.env.REACT_APP_BACKEND_URL;

// Absolute URLs (http/https) are returned as-is; relative upload URLs
// (e.g. /api/files/<id>) are prefixed with the backend base URL.
export const resolveImg = (url) => {
  if (!url) return '';
  return /^https?:\/\//.test(url) ? url : `${API}${url}`;
};
